import React, { FC, useCallback, useMemo } from 'react';
import ImportGridModal from '../ow_flatfile/ImportGridModal';
import {
	getFlatfileRecordForEquipment,
	EQUIPMENT_TYPE_MASTER_LIST_PARTIAL_FLATFILE_HEADER,
	EQUIPMENT_MASTER_FLATFILE_HEADER,
} from '../stock_locations_detail_details_page/stock_location_constants';
import { getCurrency } from '../../utils/DataAccessUtils';
import { CSV_EXPORT_DEFAULTS } from '../../utils/DataConstants';
import { connect } from 'react-redux';
import { ExportToCsv } from 'export-to-csv';
import { requiredWithValueRecordHook } from '../ow_flatfile/import_record_hooks';
import { isGLCodeAllowedBySettings } from '../../utils/InventoryUtils';

const PartialEquipmentTypeUpload: FC<any> = ({
	hideUploadPopup,
	vendorOptions,
	onDataUpload,

	currentUser,
	companyConfig,
}): React.ReactElement => {
	const userCurrency = useMemo(() => getCurrency({ currentUser }).id, [currentUser]);

	const glCodeEnabled = useMemo(() => isGLCodeAllowedBySettings(companyConfig), [companyConfig]);

	const headerDefs = useMemo(
		() => EQUIPMENT_MASTER_FLATFILE_HEADER([userCurrency], [], glCodeEnabled),
		[userCurrency, glCodeEnabled]
	);

	const onDownloadSample = useCallback(() => {
		const csvTitle = `Partial_Equipment_Type_Upload_Sample`;
		const csvExporter = new ExportToCsv({
			...CSV_EXPORT_DEFAULTS,
			filename: csvTitle,
			title: csvTitle,
			headers: headerDefs.map((h) => h.label),
		});

		const data = [
			{
				crudAction: 'create',
				...getFlatfileRecordForEquipment({}, userCurrency, headerDefs),
			},
			{
				crudAction: 'update',
				...getFlatfileRecordForEquipment({ id: 1234 }, userCurrency, headerDefs),
			},
			{
				crudAction: 'delete',
				...getFlatfileRecordForEquipment({ id: 1234 }, userCurrency, headerDefs),
			},
		];
		csvExporter.generateCsv(data);
	}, [glCodeEnabled, userCurrency, vendorOptions]);

	const recordHook = (record) => {
		return requiredWithValueRecordHook(['id'], 'crudAction', ['update', 'delete'])(record);
	};

	return (
		<ImportGridModal
			visible
			title="Partial Equipment Type Upload"
			sampleModalText="Do you want to download Sample?"
			sampleButtonText="Download Sample"
			recordHook={recordHook}
			onCancel={hideUploadPopup}
			onDownloadSample={onDownloadSample}
			fields={EQUIPMENT_TYPE_MASTER_LIST_PARTIAL_FLATFILE_HEADER(
				[userCurrency],
				vendorOptions,
				glCodeEnabled
			)}
			onDataLoad={onDataUpload}
			onComplete={hideUploadPopup}
		/>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
	companyConfig: state.company_config.detail,
});

export default connect(mapStateToProps)(PartialEquipmentTypeUpload);
